<template>
   <navbar position="fixed"
           class="msc-main-navbar"
           :transparent="transparent"
           :color-on-scroll="colorOnScroll"
           menu-classes="ml-auto">
      <template slot-scope="{toggle, isToggled}">
         <router-link v-popover:popover1 class="navbar-brand msc-navbar-brand" to="/">
            <img src="img/myschoolCafe3.png" alt="mySchool.cafe home">
         </router-link>
         <el-popover
            ref="popover1"
            popper-class="popover"
            placement="bottom"
            width="200"
            trigger="hover">
            <div class="v-b-ppopover-body mt-0 mb-0">Home Page</div>
         </el-popover>
      </template>
      <template slot="navbar-menu">
         <li>
            <router-link
               v-if="!$root.isUserAuthenticated()"
               class="nav-link btn btn-warning btn-round"
               to="/help"
            >
               <p>Help</p>
            </router-link>
         </li>

         <li>
            <router-link
               v-if="!$root.isUserAuthenticated()"
               class="nav-link btn btn-success btn-round"
               to="/signup"
            >
               <p>Register For Access</p>
            </router-link>
         </li>

         <li class="nav-item">
            <router-link
               v-if="!$root.isUserAuthenticated()"
               class="nav-link btn btn-primary btn-round"
               to="/login"
            >
               <p>Parent Login</p>
            </router-link>
            <a v-else class="nav-link btn btn-primary btn-round" @click="logout()">
               <p>Log Out, {{$root.alias()}}</p>
            </a>
         </li>
      </template>
   </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'

  export default {
    name      : 'main-navbar',
    props     : {
      transparent  : Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    },
    methods   : {
      logout() {
        let t = this;
        t.$root.logout();
        // todo: let's go to the main page now.
      }
    }
  }
</script>

<style scoped>
</style>
